/**
 * Central event bus for sync errors
 * Allows decoupled communication between services and UI
 */
class SyncErrorBus {
        /**
         * Alias for subscribe (for test compatibility)
         */
        on(id, callback) {
            return this.subscribe(id, callback);
        }

        /**
         * Remove listener by id (for test compatibility)
         */
        off(id, callback) {
            this.listeners.delete(id);
        }
    constructor() {
        this.listeners = new Map();
    }

    /**
     * Emit a sync error
     * @param {SyncError} error - Object with type, data, context
     */
    emit(event, payload) {
        // If called with one argument (legacy), treat as payload
        if (arguments.length === 1) {
            this.listeners.forEach((callback) => {
                try {
                    callback(event);
                } catch (err) {
                    console.error('Error in listener:', err);
                }
            });
        } else {
            // If called with (event, payload), pass payload to listeners
            this.listeners.forEach((callback) => {
                try {
                    callback(payload);
                } catch (err) {
                    console.error('Error in listener:', err);
                }
            });
        }
    }

    /**
     * Subscribe to errors
     * @param {string} id - Unique listener identifier
     * @param {Function} callback - Function to execute
     * @returns {Function} Cleanup function
     */
    subscribe(id, callback) {
        this.listeners.set(id, callback);
        
        return () => {
            this.listeners.delete(id);
        };
    }

    /**
     * Get number of active listeners
     */
    getListenerCount() {
        return this.listeners.size;
    }
}

export const syncErrorBus = new SyncErrorBus();
